<template>
  <div class="MainBtnGroup">
    <div
      v-if="checkShowButton"
      class="main-btns no-stock"
      :style="{'lineHeight': '52px'}"
    >
      <div
        class="addCart"
        :style="{ width: union_isBilingual ? '230px' : '180px'}"
      >
        <span v-text="responseBody.activityStateDesc"></span>
      </div>
    </div>
    <div
      v-else
      class="main-btns"
      :class="[((isGray && bizStock === null) || bizStock === 0 || fromCMS || responseBody.status === '2') && 'no-stock', epidemicDeliverInfo.allowDelivery === 0 && epidemicDeliverInfo.mandatoryType === 0 && 'epidemic-disable']"
      :style="{'lineHeight': '52px'}"
    >
      <div
        v-if="responseBody && responseBody.groupItem !== 'Y' && responseBody.purchaseType === 1 && ((!isGray && responseBody.stockStatus < 3 && bizStock === null) || bizStock > 0)"
        :class="['addCart']"
        :style="{ width: union_isBilingual ? '200px' : '180px'}"
        @click="onClickAddCart"
      >
        {{TLang('加入购物车','my')}}
      </div>
      <div
        v-if="bizStock === 0"
        class="restock"
        :style="{ width: union_isBilingual ? '200px' : '180px'}"
      >
        {{TLang('抢光了','list')}}
      </div>
      <div
        v-else-if="responseBody.stockStatus === 3 && bizStock === null"
        class="restock"
        :style="{ width: union_isBilingual ? '200px' : '180px'}"
      >
        {{TLang('补货中','list')}}
      </div>
      <div
        v-else
        :class="['goBuy']"
        :style="{ width: union_isBilingual ? '200px' : '180px'}"
        @click="onClickGoBuy"
      >
        {{ responseBody.status === '2' ? TLang('已下架','my') : TLang('立即购买','my') }}
      </div>
      <template v-if="shareImgVisible">
        <div class="detail-sheare-btn" @click='onClickShare' >
          <img class="detail-sheare-img" src="@/assets/images/icon-share.png" alt />
          <div>分享</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainBtnGroup',
  props: {
    shareImgVisible: Boolean,
    isGray: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    fromCMS: Boolean,
    epidemicDeliverInfo: {
      type: Object,
      default: function() {
        return {
          allowDelivery: null,
          mandatoryType: null,
          promptWords: null,
        };
      },
    },
    responseBody: {
      type: Object,
      default: function() {
        return {
          status: '1',
          stockStatus: 1,
          purchaseType: 1,
        };
      },
    },
    onClickAddCart: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    onClickGoBuy: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    bizStock: {
      type: Number || undefined,
      default: null,
    },
  },
  computed: {
    checkShowButton() {
      // 如果是活动商品并且状态是1：未上架 2：已上架未开始 3：已结束,使用对应按钮
      if (
        this.responseBody.activityState === 1 ||
        this.responseBody.activityState === 2 ||
        this.responseBody.activityState === 3
      ) {
        return true;
      } else {
        return false;
      }
    },
    getButtonTextEN(){
      switch(this.responseBody.activityState){
      case 1:
        return 'Sold Out';
      case 2:
        return 'Not Started';
      case 3:
        return 'End Of Promotion';
      }
    },
  },
  methods: {
    onClickShare(i) {
      this.$emit('onClickShare', i);
    },
  },
};
</script>

<style lang="less">
.MainBtnGroup {
  .main-btns {
    margin-left: 48px;
    margin-top: 32px;
    display: flex;
    color: #fff;
    text-align: center;
    // line-height: 52px;
    font-size: 16px;
    font-weight: bold;
    &:hover {
      cursor: pointer;
    }
    .addCart {
      width: 180px;
      height: 52px;
      // background: linear-gradient(
      //   315deg,
      //   rgba(85, 85, 85, 1) 0%,
      //   rgba(51, 51, 51, 1) 100%
      // );
      border: 1px solid #3FA6FF;
      color: #3FA6FF;
      border-radius: 4px;
      margin-right: 20px;
    }
    .goBuy {
      width: 180px;
      height: 52px;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
      border-radius: 4px;
    }
    .restock {
      width: 180px;
      height: 52px;
      background: linear-gradient(
        315deg,
        rgba(210, 210, 210, 1) 0%,
        rgba(178, 178, 178, 1) 100%
      );
      border-radius: 4px;
    }
  }
  .no-stock, .epidemic-disable {
    .addCart {
      background: linear-gradient(
        315deg,
        rgba(85, 85, 85, 1) 0%,
        rgba(51, 51, 51, 1) 100%
      );
      opacity: 0.5;
    }
    .goBuy {
      background: linear-gradient(
        315deg,
        rgba(85, 85, 85, 1) 0%,
        rgba(51, 51, 51, 1) 100%
      );
      opacity: 0.5;
    }
    &:hover {
      cursor: not-allowed;
    }
  }
  .detail-sheare-btn {
    color: rgba(63, 166, 255, 1);
    width: 52px;
    height: 52px;
    background: #ECF6FF;
    border-radius: 4px;
    overflow: hidden;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-left: 20px;
    line-height: 1.5;
    .detail-sheare-img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>